import React, { useState, useMemo } from 'react';
import ListGroup from "react-bootstrap/ListGroup";

const TypeBar = ({ categories, selectedCategory, setSelectedCategory, selectedType }) => {
    // Фильтруем категории по выбранному типу
    const filteredCategories = useMemo(
        () => (selectedType ? categories.filter(cat => cat.type === selectedType) : categories),
        [categories, selectedType]
    );

    // Дерево категорий (parent_id -> children)
    const categoryTree = useMemo(() => {
        const nodesById = new Map();
        filteredCategories.forEach(cat => {
            nodesById.set(cat.id, { category: cat, children: [] });
        });

        const roots = [];
        nodesById.forEach(node => {
            const parentId = node.category.parent_id;
            if (parentId && nodesById.has(parentId)) {
                nodesById.get(parentId).children.push(node);
            } else {
                roots.push(node);
            }
        });

        return roots;
    }, [filteredCategories]);

    // Какие узлы раскрыты (только для десктопа; TypeBar и так показывается на md+)
    const [expandedIds, setExpandedIds] = useState([]);
    const toggleExpand = (id) => {
        setExpandedIds(prev =>
            prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
        );
    };

    const renderNode = (node, level = 0) => {
        const { category, children } = node;
        const hasChildren = children && children.length > 0;
        const isExpanded = expandedIds.includes(category.id);
        const isActive = selectedCategory && selectedCategory.id === category.id;

        const paddingLeft = 12 + level * 18;

        return (
            <React.Fragment key={category.id}>
                <ListGroup.Item
                    className="typebar-item"
                    style={{ cursor: 'pointer', paddingLeft }}
                    active={isActive}
                    onClick={() => setSelectedCategory(category)}
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        {hasChildren && (
                            <span
                                onClick={(e) => {
                                    e.stopPropagation();
                                    toggleExpand(category.id);
                                }}
                                aria-label={isExpanded ? 'Свернуть подразделы' : 'Развернуть подразделы'}
                                style={{
                                    display: 'inline-flex',
                                    width: 14,
                                    justifyContent: 'center',
                                    fontSize: 12,
                                    color: '#6c757d',
                                }}
                            >
                                {isExpanded ? '▾' : '▸'}
                            </span>
                        )}
                        {!hasChildren && (
                            <span style={{ width: 14 }} />
                        )}
                        <span>{category.name}</span>
                    </div>
                </ListGroup.Item>
                {hasChildren && isExpanded && children.map(child => renderNode(child, level + 1))}
            </React.Fragment>
        );
    };

    return (
        <ListGroup className="typebar-list">
            {categoryTree.map(node => renderNode(node))}
        </ListGroup>
    );
};

export default TypeBar;